export default __webpack_public_path__ + "static/BETTERIRL_PINK-9a75661638a5f61ff2b8760f09666cea.png";